import React from 'react';
import { palette } from '../styles/Palette';

const ProjectTag = ({ width = "20", height = "14", color = palette.gray500, ...props }) => {
  return (
    <svg 
      xmlns="http://www.w3.org/2000/svg" 
      width={width} 
      height={height} 
      viewBox="0 0 20 14" 
      fill="none"
      {...props}
    >
      <path d="M7.27273 10.7143H12.7273C12.9848 10.7143 13.2009 10.6251 13.3755 10.4469C13.55 10.2686 13.637 10.0482 13.6364 9.78571V6.07143C13.6364 5.80833 13.5491 5.58795 13.3745 5.41028C13.2 5.23262 12.9842 5.14348 12.7273 5.14286H11.8182V4.21429C11.8182 3.95119 11.7309 3.73081 11.5564 3.55314C11.3818 3.37548 11.1661 3.28633 10.9091 3.28571H9.09091C8.83333 3.28571 8.61758 3.37486 8.44364 3.55314C8.2697 3.73143 8.18242 3.95181 8.18182 4.21429V5.14286H7.27273C7.01515 5.14286 6.79939 5.232 6.62545 5.41028C6.45152 5.58857 6.36424 5.80895 6.36364 6.07143V9.78571C6.36364 10.0488 6.45091 10.2695 6.62545 10.4478C6.8 10.6261 7.01576 10.7149 7.27273 10.7143ZM9.09091 5.14286V4.21429H10.9091V5.14286H9.09091ZM6.36364 13.5C4.59091 13.5 3.08727 12.8695 1.85273 11.6085C0.618182 10.3475 0.000606506 8.81133 4.45633e-07 7C-0.000605615 5.18867 0.61697 3.65281 1.85273 2.39243C3.08849 1.13205 4.59212 0.501238 6.36364 0.5H13.6364C15.4091 0.5 16.913 1.13081 18.1482 2.39243C19.3833 3.65405 20.0006 5.1899 20 7C19.9994 8.81009 19.3821 10.3463 18.1482 11.6085C16.9142 12.8707 15.4103 13.5012 13.6364 13.5H6.36364Z" fill={color} />
    </svg>
  );
};

export default ProjectTag; 